import { React, useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import H2 from './H2';
import Slider from './Slider';
import GuideCard from './GuideCard';
import Modal from './ModalComponent/Modal';
import MeetGuidesModal from './ModalComponent/MeetGuidesModal';

function ActionButton({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      className="text-normal hover:bg-secondary-main-light mt-[30px] w-full rounded-full border border-solid border-dark-900 bg-transparent py-3 px-6 font-poppins font-medium leading-none text-dark-800 focus:outline-none  md:w-auto"
      type="button"
    >
      {children}
    </button>
  );
}

function MeetGuides({ trip }) {
  const data = {
    title: 'Meet your guides',
    button: 'show guide details',
  };
  const list =
    trip?.attributes?.events?.map((event) => event?.guide?.data).filter((guide) => guide) || [];
  const uniqueGuides = [...new Set(list.map((guide) => guide?.id))];
  const guides = uniqueGuides.map((id) => {
    return list.find((guide) => guide?.id === id);
  });

  const [showModal, setShowModal] = useState(false);

  if (!guides || !guides.length) return null;

  return (
    <>
      <div className="hidden border-t border-solid border-dark-50 lg:block">
        <H2 className="pb-[32px] pt-16 text-dark-800" text={data.title} />
        <div
          onClick={() => {
            setShowModal(true);
          }}
          className="hidden gap-8 xl:flex cursor-pointer"
        >
          {guides.map((guide) => (
            <GuideCard key={guide.id} guide={guide} />
          ))}
        </div>
        <div
          className="pb-16 text-center md:text-left"
          onClick={() => {
            setShowModal(true);
          }}
        >
          <ActionButton>Show guide details</ActionButton>
        </div>
      </div>

      <Slider slidesPerView="auto" spaceBetween={10} title={data.title} className="block lg:hidden">
        {guides.map((guide) => (
          <SwiperSlide key={guide.id}>
            <div
              onClick={() => {
                setShowModal(true);
              }}
            >
              <GuideCard guide={guide} />
            </div>
          </SwiperSlide>
        ))}
      </Slider>
      <div className="text-center md:text-left lg:hidden">
        <ActionButton>Show guide details</ActionButton>
      </div>
      <Modal showModal={showModal} setShowModal={setShowModal} notRounded noButtons>
        <MeetGuidesModal title={data.title} guides={guides} />
      </Modal>
    </>
  );
}

export default MeetGuides;
